<template>
  <div class="AppBody">
    <!--      <app-init></app-init>-->
    <el-container>
      <el-header>
        <AppTopNav></AppTopNav>
      </el-header>
      <el-container class="container2">
        <el-aside width="230px">
          <AppNav></AppNav>
        </el-aside>
        <el-main>
          <router-view
              v-if="initFinish"
              ref="routerView"/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AppTopNav from "@/components/layout/AppTopNav.vue";
import AppNav from "@/components/layout/AppNav.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "AppBody",
  components: {AppNav, AppTopNav},
  computed: {
    ...mapState("user", ["permissionCode"])
  },
  data() {
    return {
      initFinish: false
    }
  },
  async mounted() {
    let userTenants = await this.getUserTenants();
    let tenantsList = userTenants.data;
    let tenantId = localStorage.getItem("tenantId");
    if (tenantId === null) {
      tenantId = String(tenantsList.length > 0 ? tenantsList[0].id : 0);
      localStorage.setItem("tenantId", tenantId);
    }
    this.setData({key: "tenantName", value: ""})
    for (const tenant of tenantsList) {
      if (tenantId === String(tenant.id)) {
        this.setData({key: "tenantName", value: tenant.name})
        break;
      }
    }
    await Promise.all([this.getUserPermission(), this.getUserInfo(), this.getTenantConfig()])

    let code = this.$router.currentRoute.meta.permissionCode;
    if (code && !this.permissionCode.has(code)) {
      this.goToFirstMenu();
    }
    this.initFinish = true;

    this.$router.beforeEach((to, from, next) => {
      let permissionCode = to.meta.permissionCode;
      if (permissionCode && !this.permissionCode.has(permissionCode)) {
        this.goToFirstMenu();
      } else {
        next();
      }
      this.getSystemMessage({size: 20});
    })
  },
  methods: {
    ...mapActions("user", ["getUserInfo", "getUserPermission", "getSystemMessage"]),
    ...mapActions("tenant", ["getUserTenants", "getTenantConfig"]),
    ...mapMutations("user", ["goToFirstMenu"]),
    ...mapMutations("tenant", ["setData"]),
  },
};
</script>

<style lang="scss">
@import "src/styles/reset";
@import "src/styles/element-ui";
@import "src/styles/variables";

.AppBody {
  .container2 {
    height: calc(100vh - 60px);

    .el-aside {
      color: #333;
      line-height: 200px;
      overflow-y: scroll;
      padding-right: 0;
    }

    .el-aside::-webkit-scrollbar {
      background-color: transparent; /* 背景色为透明 */
      border: none; /* 没有边框 */
    }


    .el-main {
      background-color: #e9eef3;
      color: #333;
      padding: 0 10px 10px 10px;
    }
  }
}
</style>
